<script>
import resources from './resources'

export default {
  name: 'moving',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Agendamento
          |   - {{ moving.go_in_out }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
               v-if="user.id === moving.user.id"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.moving.edit', params: {id: moving.id, tower_id: moving.tower_id, unit_id: moving.unit_id}}") Editar
              li
      .body
        h6.m-b-15
          | {{ moving.go_in_out }}
          span.badge.badge-default.float-right UNIDADE {{ moving.unit.number }} &nbsp; - &nbsp;
            i.zmdi.zmdi-circle.offline(v-if="moving.type === 'out'")
            i.zmdi.zmdi-circle.online(v-if="moving.type === 'in'")
        .row
          .col-5
            small
              strong VALOR :

          .col-7
            small
              strong TORRE:
        .row
          .col-5
            small.float-left
              | R$ {{ moving.price }}
          .col-7
            small
              | {{ moving.tower.name}}
        .row
          .col-5
            small
              strong MORADOR:

          .col-7
            small
              strong FONE:
        .row
          .col-5
            img.team-info.cursor-pointer(
              :src='moving.user.image.url',
              :title="moving.user.name",
              :alt='moving.user.name'
              v-if="moving.user.image !== null",
            )
            img.team-info.cursor-pointer(
              src='/static/images/profile_av.jpeg',
              :title="moving.user.name",
              :alt='moving.user.name'
              v-if="moving.user.image === null",
            )
          .col-7
            small {{ maskPhone(moving.user.phone) }}
            br
            small {{ moving.user.name }}

</template>
<style scoped>
  .team-info {
      width: 42px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      border-radius: 50%;
      border: 2px solid #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      margin-top: 0px;
  }
  .online {
    color: #86BB71;
  }
  .offline {
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/moving/index/components/item.vue